import { Link } from "react-router-dom";
import styled from "styled-components";
import { Container } from "../components/ui";

export default function NotFound() {
  return (
    <Wrap>
      <Container>
        <Code>404</Code>
        <H1>Kjo faqe nuk ekziston</H1>
        <P>Ndoshta linku është i vjetër, ose ka një gabim në adresë.</P>
        <Back to="/">Kthehu te faqja kryesore</Back>
      </Container>
    </Wrap>
  );
}

const Wrap = styled.div`
  min-height: 72svh;
  display: flex;
  align-items: center;
  padding: 160px 0 100px;
  text-align: center;
`;

const Code = styled.div`
  font-family: ${({ theme }) => theme.font.display};
  font-size: ${({ theme }) => theme.size.h2};
  color: ${({ theme }) => theme.colors.brand};
  margin-bottom: 12px;
`;

const H1 = styled.h1`
  font-size: ${({ theme }) => theme.size.h2};
  margin-bottom: 14px;
`;

const P = styled.p`
  color: ${({ theme }) => theme.colors.inkSoft};
  margin-bottom: 30px;
`;

const Back = styled(Link)`
  display: inline-flex;
  padding: 15px 30px;
  border-radius: 999px;
  background: ${({ theme }) => theme.colors.ink};
  color: #fff;
  font-size: ${({ theme }) => theme.size.sm};
  font-weight: 500;
`;
